import { ajaxSend } from '../../../api/api';
const basePath = '/v1/integrations/customcard';
const basePathV3 = '/v3/integrations/customcards';
export function getCustomCardById(id) {
    if (!id) {
        return undefined;
    }
    return ajaxSend({
        method: 'GET',
        path: `${basePathV3}/${id}`,
    });
}
export function getCustomCards() {
    return ajaxSend({
        method: 'GET',
        path: `${basePath}`,
    });
}
export function testCustomCard({ id, query, template, }) {
    if (!id) {
        return undefined;
    }
    /**
     * Test endpoints are currently being changed to v3. Until all new endpoints
     * are in v3 we have to distinguish between a normal test (old v1) and a new
     * test with an optional template override (new v3). See: TEAMS-6730
     */
    const path = template ? `${basePathV3}/${id}/test` : `${basePath}/${id}`;
    const method = template ? 'PUT' : 'GET';
    return ajaxSend(Object.assign({ method, path: `${path}${query ? query : ''}` }, (template && { data: { template } })));
}
export function editCustomCard(payload) {
    if (payload === undefined || payload === null) {
        return undefined;
    }
    return ajaxSend({
        method: 'PUT',
        path: `${basePath}`,
        data: payload,
    });
}
export function removeCustomCard(payload) {
    if (payload === undefined || payload === null) {
        return undefined;
    }
    return ajaxSend({
        method: 'DELETE',
        path: `${basePath}/${payload.hook.hook_id}`,
    });
}
export function addCustomCard(payload) {
    if (payload === undefined || payload === null) {
        return undefined;
    }
    return ajaxSend({
        method: 'PUT',
        path: `${basePath}`,
        data: payload,
    });
}
